import { createEmployeeCardRendering } from 'scripts/renderings/employee-rendering';
import $ from 'jquery';

export const init = (jsonConfig) => {
  const employeeCards = jsonConfig.employees.map((employee) => createEmployeeCardRendering(employee, jsonConfig.texts));
  $('#employees-on-frontpage-container').append(employeeCards);
};
